export enum ParticipationState {
  Intended = "INTENDED", // vorgesehen
  Invited = "INVITED", // aufgefordert
  Registered = "REGISTERED", //bestätigt
}
